module.exports = __webpack_public_path__ + "mstile-150x150.png";


//////////////////
// WEBPACK FOOTER
// ./src/icon/mstile-150x150.png
// module id = 21
// module chunks = 0